module.exports = __webpack_public_path__ + "img/stretch--genre2-img2.594ea97a.jpg";